// @flow
export { default } from './EventContent';



// WEBPACK FOOTER //
// ./src/components/event/EventContent/index.js